<template>
  <div class="ttg">
    <h2 class="title">Time to goal trough</h2>กรณีคนไข้มีระดับยาสูงเกินและต้องการ hold ยาจนระดับยาลงมาอยู่ในช่วงปกติ
    <ul id="input">
      <li>
        Ke
        <input class="input" type="integer" v-model="ke" size="6px"> hr-1
      </li>

      <li>
        Vancomycin level
        <input class="input" type="integer" v-model="level" size="3px">
        mcg/ml
      </li>
      <li>
        Target level
        <input type="range" min="5" max="25" step="5" v-model="targetlevel">
        
        <input class="input" type="integer" v-model="targetlevel" size="3px">mcg/ml
      </li>
      <li>
        <div id="result">
          ระดับยาจะลดลงจาก {{level}} เหลือ {{targetlevel}} mcg/ml
          <br>
          เมื่อผ่านไป {{ttgtcalc.toFixed(0)}} ชั่วโมง
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ttg",
  data() {
    return {
      ke: 0.07,
      level: 30,
      targetlevel: 15
    };
  },
  computed: {
    ttgtcalc() {
      return Math.log(this.level / this.targetlevel) / this.ke;
    }
  }
};
</script>

<style scope >
ul#input li {
  display: list-item;
  list-style-type: none;
  margin-top: 10px;
}
div#result {
  font-size: 18px;
  color: black;
  background-color: #fccbcb;
}
</style>